//import React from "react";
import PropTypes from "prop-types";
import React, { useState, useRef } from "react";
import withRouter from "components/Common/withRouter";

import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Input,
  Row,
  Button, 
  FormFeedback
} from "reactstrap"

import { ToastContainer } from "react-toastify";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { 
  Formik, 
  //Form, 
  Field, 
  FieldArray, 
  ErrorMessage } from "formik";

// import images
import logodark from "../../assets/images/logo-cinzan-edu.png"
import logolight from "../../assets/images/logo-cinzan-edu.png"


import {
    createPassword as onCreatePassword,

  
} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";



const ResetPassword = (props) => {

  

  //meta title
  document.title = "Création de mot de passe | CinzanEdu";

  //const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const inputsRef = useRef([]);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const password_token = queryParams.get("token");

   const dispatch = useDispatch();


  //form validation
    const validation = useFormik({
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,
  
      initialValues: {
        password: '',
        password_confirmation: '',
      },
      validationSchema: Yup.object({
       
        password: Yup.string()
            .min(8, "Le mot de passe doit contenir au moins 8 caractères.")
            .required("Veuillez entrer votre mot de passe."),
            
        password_confirmation: Yup.string()
            .required("Veuillez confirmer votre mot de passe.")
            .oneOf([Yup.ref('password'), null], 'Les mots de passe ne correspondent pas.'),
      }),
      onSubmit: (values) => {


        // Enlever les guillemets
        //const token = JSON.parse(localStorage.getItem("reset_password_token"));
        //const password_token = JSON.parse(localStorage.getItem("reset_password_token"));
        //const token = localStorage.getItem("reset_password_token") ? JSON.parse(localStorage.getItem("reset_password_token")) : null;

       

        const data = {
               
          password_token: password_token,
          password: values["password"],
          password_confirmation: values["password_confirmation"],
         
        
        };

        //console.log("DATA BEFORE SEND: ", data);

        
        //dispatch(onCreatePassword(payload,props.router.navigate));
        dispatch(onCreatePassword({data,  history: props.router.navigate}));
     
        validation.resetForm();
          }
    });




  

  
  /*
  const handleSubmit = async (values) => {


   
    const data = {
                   
      password: values["password"],
      password_confirmation: values["password_confirmation"],
     
  };
    
    dispatch(onCreatePassword(data,props.router.navigate));
    validation.resetForm();
    

  };

  */

 



  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="20"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="20"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/*<p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-lock-open-alt h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Création de mot de passe</h4>
                        <p className="mb-5">
                          {/*Veuillez saisir le code à 6 chiffres envoyé dans votre email.*/}
                          {/* à{" "}
                          <span className="fw-semibold">
                            www.yetaplus.com
                          </span>*/}
                        </p>

                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}

                            //enableReinitialize={true}
                        >
                        <div>
                          
                          <Row className="justify-content-center mb-3">
                            <div className="mb-3">
                              <Label className="form-label">Mot de passe</Label>
                              <Input
                                name="password"
                                type="password"
                                placeholder="Mot de passe"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={
                                  validation.touched.password && validation.errors.password ? true : false
                                }
                              />
                              {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Confirmation du mot de passe</Label>
                              <Input
                                name="password_confirmation"
                                type="password"
                                placeholder="Confirmation du mot de passe"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password_confirmation || ""}
                                invalid={
                                  validation.touched.password_confirmation && validation.errors.password_confirmation ? true : false
                                }
                              />
                              {validation.touched.password_confirmation && validation.errors.password_confirmation ? (
                                <FormFeedback type="invalid">{validation.errors.password_confirmation}</FormFeedback>
                              ) : null}
                            </div>
                          </Row>

                         
                          <Button color="success" type="submit" className="w-100">
                            Confirmer
                          </Button>
                   </div>
                        </Form>

                        <div className="mt-4">
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                {/*
                <p>
                  Vous n'avez pas reçu de code ?{" "}
                  <a href="#" className="fw-medium text-primary">
                    {" "}
                    Renvoyer{" "}
                  </a>{" "}
                </p>
                */}
                <p>
                  © {new Date().getFullYear()} CinzanEdu. Développez avec{" "}
                  <i className="mdi mdi-heart text-danger"></i> par CERTES
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}
//export default AcceptInvitation;
export default withRouter(ResetPassword);

ResetPassword.propTypes = {
  history: PropTypes.object,
};
